<template>
  <section class="layoutLayout weflix-admin-socialMediaLayout">
    <TitlePage title="Redes Sociais" subtitle="Personalize suas redes sociais e contatos para seu site" :hasMargin="true" />
      <div class="content-form" v-if="hasReady">
        <div class="row">
          <div class="col-form-outer col-12 col-md-12 col-lg-12">
            <div class="list">
              <div class="social-media-card" v-for="(item, index) in names" :key="index">
                <div class="social-media-header">
                  <div class="social-icon" :class="{'active': activeSocial[index]}">
                    <fa :icon="['fab', socialIcons[index]]" :style="activeSocial[index] ? {color: socialColors[index]} : {}" />
                  </div>
                  <span class="social-name">{{ item }}</span>
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      v-model="activeSocial[index]"
                      :id="'socialSwitch' + index"
                    />
                  </div>
                </div>
                <div class="social-media-input">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="placeholders[index]"
                    v-model="linkSocial[index]"
                    :disabled="!activeSocial[index]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actionsSave" id="layoutSocialMediaWeflix">
        <v-btn variant="outlined" border="2" color="primary" size="large" width="140" @click="editSocialMedia">Salvar</v-btn>
      </div>
  </section>
 
<Loader :hasReady="hasReady" />
</template>

<script>
import apiSiteSocialMidia from '@/utils/Weflix/socialMedia';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
  data() {
    return {
      hasSaved: false,
      data:[],
      activeSocial: Array(6).fill(false),
      linkSocial: Array(6).fill(''),
      names: ['Facebook', 'Instagram', 'Youtube', 'Linkedin', 'Whatsapp', 'TikTok'],
      socialIcons: ['facebook-f', 'instagram', 'youtube', 'linkedin-in', 'whatsapp', 'tiktok'],
      socialColors: ['#1877f2', '#e4405f', '#ff0000', '#0077b5', '#25d366', '#000000'],
      placeholders: [
        'facebook.com/suapagina',
        'instagram.com/suapagina',
        'youtube.com/canal',
        'linkedin.com/empresa',
        'whatsapp.com/numero',
        'tiktok.com/@usuario'
      ],
      hasReady: false
    };
  },
  computed: {
    ...mapState(['token']),
  },
  components: {
    Loader,
    TitlePage
  },
  methods: {
    async editSocialMedia() {
      this.hasReady = false;
      const socialData = [];
      const newItems = [];

      this.linkSocial.forEach((link, index) => {
        if(link!==''){
          const id = this.data[index] ? this.data[index].id : null;
          const status = this.activeSocial[index] ? 1 : 0;
          const url = link ? link : null;
          const type = index;
          const name = this.names[index];

          if (id) {
            socialData.push({ id, name, type, url, status });
          } else if (this.activeSocial[index] == 1) {
            newItems.push({ name, type, url, status });
          }
        }
      });

      try {
        if (socialData.length > 0) {
          await apiSiteSocialMidia.editSocialMidias(this.token, socialData);
          this.hasReady = true;
        }

        if (newItems.length > 0) {
          await apiSiteSocialMidia.postSocialMidiastData(this.token, newItems);
          this.hasReady = true;
        }

        this.getDataSocialMedia();
        this.notify('Redes sociais atualizadas com sucesso!', 'success');
      } catch (error) {
        console.error(error);
        this.notify('Erro ao obter dados das redes sociais.', 'error');
      }
    },
  
    async getDataSocialMedia(){
      try {
        const response = await apiSiteSocialMidia.getSocialMidia(this.token);
        this.data = response;
        this.data.forEach((item) => {
          this.activeSocial[item.type] = item.status === 1;
          this.linkSocial[item.type] = item.url;
        });
        this.hasReady = true;
      } catch (error) {
        console.error(error);
      }
    },
    notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
  },
  props: {
    saved: Boolean,
  },
  created() {
    this.getDataSocialMedia();
  },
};
</script>

<style scoped>
@import url('./css/social.css');
</style>
